/*
 * Public API Surface of ng-select2-component
 */

export * from './lib/select2-interfaces';
export * from './lib/select2-const';
export * from './lib/select2.component';
export * from './lib/select2.component';
export * from './lib/select2-hint.component';
export * from './lib/select2-label.component';
export * from './lib/select2-utils';
export * from './lib/select2.module';
